
import { ImSpinner10 } from 'react-icons/im';
// import { BASE } from '../http';

export function Loading() {
  return (
    <div style={{ position: 'absolute', height: '100%', top: '0px', right: '0px', width: "100%", zIndex: 4500 }}>
      <div className={'d-flex justify-content-center align-items-center'}
        style={{ backgroundColor: '#252d3247', height: '100%' }}>
        <p className='center white text-shadow bold' style={{ fontSize: '20px' }}>
          <ImSpinner10 size={25} className='icon-spin' color={'#fff'} />
          <br /> Please wait ...
        </p>
      </div>
    </div>
  );
}


export function LagendComp() {

  return (
    <div className="row">
      <div className="col-md-12">
        <h3> Map Lagend</h3>
      </div>
    </div>
  );
}

type ImgProps = {
  src: string;
  title?: string;
  className?: string;
  alt?: string;
  id?: string;
  attr?: string;
  clickfunc?: ({ target, preventDefault }: React.SyntheticEvent<HTMLImageElement>) => void;
  style?: Record<string, string | number>;
}

export function Img({ src, title, className, alt, attr, clickfunc, id, style }: ImgProps) {

  // comment out line 44 before deploying
  // const base = `http://localhost:9090${src}` // comment before deploying

  let base = process.env.REACT_APP_BASE + src; // for deployment use this line.

  return <img
    title={title}
    className={className}
    src={base} alt={alt}
    onClick={clickfunc}
    id={id}
    data-attr={attr}
    style={style}
  />

}


export const ActionBar = ({
  search, btnfunc, searchfunc,
  classname, placeholder, btnicon,
  btntitle }: ActionBarType) => {

  return (
    <div className="container-fluid">
      <div className="row">
        <div className={classname}>
          <div className="d-flex justify-content-between">
            <div>
              {
                search ? (
                  <input
                    type="text"
                    onChange={searchfunc!}
                    className="form-control form-control-lg"
                    placeholder={placeholder}
                  />
                ) : null
              }
            </div>
            {
              btnfunc ? (
                <div className="d-grid gap-2 col-md-3 col-sm-12">
                  <a href="#" className="btn btn-primary btn-lg" onClick={btnfunc}>
                    {btnicon ? btnicon : null}  &nbsp; {btntitle || 'Add'}
                  </a>
                </div>
              ) : null
            }
          </div>
        </div>
      </div>
    </div>
  )

} 


export const BoxArea = ({ classname, children, nopadding }: BoxAreaType) => {

  return (
    <div className={classname}>
      <div className='box-area bg-white shadow' style={{padding: nopadding? '0px': '20px', marginBottom: '20px'}}>
        {children}
      </div>
    </div>
  )
}


